import React from 'react';
import { Save, Loader } from 'lucide-react';

/**
 * Save button component with loading state
 */
const SaveButton = ({ onSave, isLoading, hasUnsavedChanges, disabled }) => {
  return (
    <button
      className={`landing-button landing-button-outline ${
        !hasUnsavedChanges ? 'saved' : ''
      }`}
      onClick={onSave}
      disabled={isLoading || disabled || !hasUnsavedChanges}
      aria-label="Save landing page"
      aria-busy={isLoading}
    >
      {isLoading ? (
        <>
          <Loader className="spinner" size={16} />
          Saving...
        </>
      ) : (
        <>
          <Save size={16} />
          {hasUnsavedChanges ? 'Save Changes' : 'Saved'}
        </>
      )}
    </button>
  );
};

export default SaveButton;

